export default {
  Forex_Leverage: 'Forex Leverage',
  handerImgRightTips: [
    'Clear facial display',
    'ID card information is fully presented',
    'Suitable light',
    'Background solid color',
  ],
  handerImgWrongTips: [
    'The photo is blurry and out of focus',
    'Details not clearly displayed',
    'Face occlusion problem',
    'ID card obstruction',
  ],
  No_handling_fee_is_charged_funds_are_withdrawn_to_your_own_MT4_account: 'No handling fee is charged, funds are withdrawn to your own MT4 account',
  Unlimited_amount: 'Unlimited amount',
  Transfer_to_MT4_account: 'Transfer to MT4 account',
  Agent_Backstage: 'Agent Area',
  Convert_to_IB: 'Convert to IB',
  Bank_Name: 'Bank Name',
  Annex_1: 'Attachment 1',
  Annex_2: 'Attachment 2',
  Return_to_old_version: 'Return to old version',
  If_the_old_phone_cannot_be_used_please_contact_customer_service_to_request_modification: '*If current mobile phone number cannot be used, please contact customer service to request modification',
  Current_mobile_phone_number: 'Current mobile phone number',
  Bonus_Account: 'Bonus Account',
  Redemption_Details: 'Redemption Details',
  Contact_Number: 'Contact Number',
  Consignees_name: "Consignee's name",
  Apply_for_redemption: 'Apply for redemption',
  Order_Information: 'Order Information',
  Please_fill_in_the_delivery_address: 'Please fill in the delivery address',
  Delivery_address: 'Delivery address',
  Confirm_your_order: 'Confirm your order',
  Go_to_checkout: 'Go to checkout',
  Deduction_of_points: 'Deduction of points',
  My_Points: 'My Points',
  integral: 'integral',
  Select_All: 'Select All',
  Cart: 'Cart',
  add_to_the_cart: 'add to the cart',
  Sales: 'Sales',
  Sticky: 'Sticky',
  Start_Activation: 'Start Activation',
  Convenience_store_code_payment: 'Convenience store code payment',
  Card_punch: 'Card swipe online banking',
  Channel_Type: 'Channel Type',
  payment_bank:"Paying bank",
  direct_bank_connection:'Direct bank connection',
  scan_the_code_for_online_banking:'Online banking scan code',
  Bank_Code: 'Bank_Code',
  Player_Account: 'Payment Account',
  Supermarket_Code: 'Convenience store code',
  Account_Source: 'Account Source',
  homePage: {
    currency: 'currency'
  },
  Usernames_are_not_allowed_to_contain_special_characters: 'No special characters',
  Cent_accounts_allow_two_decimal_places_other_accounts_allow_one_decimal_place: 'Cent accounts allow four decimal places, other accounts allow one decimal place',
  Cent_account_Stock_type_allows_two_decimal_places: 'Cent account Stock type allows two decimal places',
  mt4DetailSetting: {
    leverTips: [
      '1、Equity<1000，max fx-leverage :1000',
      '2、Equity<50000，max fx-leverage :500',
      '3、Equity<100000，max fx-leverage :400',
      '4、Equity<200000，max fx-leverage :200',
      '5、Equity>=200000，max fx-leverage :100',
    ],
  },
  faq: {
    Account_related: 'Account related',
    Agency_related: 'Agency related',
    Transaction_related: 'Transaction related',
    Deposits_and_withdrawals: 'Deposits and withdrawals',
  },
  navBar:{
    Switch_to_customer: 'Switch to customer',
    Switch_to_IB: 'Switch to IB',
  },
  menu: {
    Commission_details: 'Commission details',
  },
  customerHome:{
    Account_type_settings: 'Account type settings',
    MAM_master: 'MAM Master',
    MAM_invest: 'MAM Invest',

  },
  copyMaster:{
    No_trading_cycle_yet: 'No trading cycle yet',
    public: 'Public',
    private: 'Private',
    Have_a_subscription_password: 'Have a subscription password',
    No_subscription_password: 'No subscription password',
    No_subscription_yet: 'No subscription yet',
    Number_of_managed_accounts: 'Managed accounts',
    copy_pay: 'Copy pay',
    Please_subscribe_to_the_trader_first_and_then_view_the_details: 'Please subscribe to the trader first and then view the details',
    view_the_details: 'View the details',
    strategy: 'Strategy',
    Not_active: 'Inactivated',
    Subscribe_to_Trader: 'Subscribe to Trader',
    key_words: 'Key Words',
    Subscription_time: 'Subscription time',
    Subscription_status: 'Subscription status',
    pause: 'Pause',
    No_active_subscription_yet: 'No active subscription yet',
    Go_subscribe_now: 'Go subscribe now',
    investment: 'Investment',
    MAM_status: 'MAM status',
    mounth: 'mounth',
  },
  bonusList: {
    Deposit_Activity_Account: 'Deposit/Activity Account',
    Deposit_account: 'Deposit account',
    Activity_Account: 'Activity Account',
    Deposit_Time: 'Deposit Time',
    Cancel_bonus: 'Cancel bonus',
    Apply_for_regularization: 'Apply for regularization',
    Cancel_credit: 'Cancel credit',
    Passed_the_regularization: 'Passed the regularization',
    Rejection_of_regularization: 'Rejection of regularization',

  },
  USD_account: 'USD account',
  Cent_Account: 'Cent Account',
  // 菜单start
  Bonus_management: 'Bonus',
  home: 'Home',
  My_profile: 'Profile',
  funds_management: 'Fund',
  Download_Center: 'Download',
  trading_software: 'Trading Software',
  // 菜单end

  // 新加的sart
  commission: 'Commission',
  Only_jpg_png_images_can_be_uploaded_and_should_not_exceed_10MB: 'Only jpg/png images can be uploaded and should not exceed 10MB',
  integral_Shop: 'Rewards Mall',
  product_detail: 'Product Detail',
  security_settings: 'Security Settings',
  Withdraw: 'Withdraw',
  funds_list: 'Fund Report',
  audit_list: 'Review',
  trader_Report: 'Trade Report',
  announcement: 'Notice',
  transaction_documents: 'Transaction Document',
  Files: 'Documents',
  Agent_area: 'Agent Area',
  My_promotion: 'Invitation Link',
  My_customer: 'Client List',
  Symbol_Statistics: 'Symbol Report',
  Commission_Statistics: 'Commission Report',
  Performance_Statistics: 'Revenue Report',
  Opening_lot: 'Open Lots',
  Submission_for_review_successful: 'Submission for review successful',
  withdraw365: 'ChipPay(OTC365)',
  please_enter_user_name: 'please input user name',
  Please_select_the_payment_account: 'Please select the payment account',
  // 新加的end

  Price: 'Price',
  Way: '-',
  Activation_successful: 'Activation successful',
  Please_enter_the_activation_code: 'Please enter the activation code',
  Active_account: 'Activate',
  Charged_when_the_trading_cycle_is_enabled_Performance_fees_are_as_shown_below_and_are_charged_at_settlement: 'Charged when the trading cycle is enabled. Performance fee will charged at settlement and shown as below.',
  my_subscription: 'My subscription',
  and_activate: 'and activate',
  Please_check_your_email: 'Please check your email',
  Email_sent: 'Email sent',
  recertification: 'Recertification',
  Data_review_failed: 'Data verification failed',
  The_estimated_review_time_is_1_3_working_days_please_be_patient: 'Data verification is estimated to take 1-3 working days, please be patient.',
  To_verify_your_identity_information_please_prepare_your_ID_card_passport_and_ID_photo: 'To verify your identity information, please have your ID card (passport) and ID photo ready',
  Activation_email_sent: 'Activation email sent',
  Demo_account_opened_successfully: 'Demo account opened successfully',
  Account_ratings_in_the_past_13_weeks: 'Account ratings in the past 13 weeks',
  sign_out: 'Sign out',
  View_rebate_rules: 'Commission rules',
  Please_enter_the_sub_IB_level_name: 'Please enter the link name',
  Add_sub_IB_link: 'Add link',
  Sub_IB_level_name: 'Link name',
  Unable_to_apply_due_to_incomplete_information_or_failed_review: 'Unable to apply due to incomplete information or failed review',
  The_commission_cannot_be_exceeded: 'The commission cannot be exceeded',
  Commission_can_be_withdrawn: 'Available commission',
  Recommended_traders: 'Recommended trader',
  My_MAM_account: 'MAM Account',
  Search_trader_nickname: 'Search by nickname',
  The_MAM_main_account_can_be_entrusted_to_manage_account_funds_and_independent_transactions_are_not_supported: 'Asset Management main trading account,setting the management fee and start trading.',
  MAM_investment_accounts_can_be_entrusted_to_manage_their_account_funds_and_charge_corresponding_fees_to_support_independent_transactions: 'Investors copy the main account to manage funds, only follow main account and self trading is not allowed.',
  Open_an_account: 'Start',
  MAM_main_account: 'MAM Master',
  Use_CopyMaster_to_open_a_new_world_of_trading: 'Copymaster takes you into a new world of trading.',
  commission_contribution: 'Total commission',
  net_deposit: 'Net deposit',
  Add_direct_customer: 'Add customers',
  Please_select_a_time: 'Please select time',
  serial_number_num: '#',
  Number_of_lots_to_close_position: 'Close Lots',
  Number_of_trading_accounts: 'Account(s)',
  Sub_IB_name_ID: 'IB name/ID',
  Direct_customer_name_ID: 'Client name/ID',
  Statistics_Time: 'Time',
  Approval_Status: 'Status',
  total_commission: 'Total',
  outside_commission: 'Commission',
  inner_commission: 'Rebate',
  Attributed_Customer_IB: 'Superior',
  Source_of_rebate: 'Source',
  Commission_record: 'Commission record',
  Belong_to_customers: 'Superior',
  MT_group: 'Group',
  Customer_Name_ID_Trading_Account: 'Name/ID/MT4',
  sub_IB: 'Sub-IB',
  Straight_off: 'Client',
  Agent_level: 'Level',
  Agent_name: 'Name',
  Agent_Name_ID: 'Name/ID',
  Direct_customer_list: 'Client List',
  Certification_status: 'Status',
  Customer_Name: 'Name',
  Select_channel: 'Select channel',
  Sub_IB_link: 'IB link',
  Commission_is_available: 'Available Amount',
  Customet_Equity: 'Clients Equity',
  System_Information: 'Messages',
  privacy_agreement: 'Privacy agreement',
  risk_agreement: 'Risk agreement',
  Use_RS_APP_to_manage_your_account_and_make_quick_transactions: 'Use Maxain APP to manage your account and trade quickly',
  Download_instructions_After_downloading_you_can_install_the_APK_through_your_mobile_phone: 'Download instructions: Download and install the APK on your android phone',
  Download_instructions_iPhone_and_iPad_users_can_search_for_MetaTrader4_and_install_it_through_the_Apple_App_Store: 'Download instructions: iPhone and iPad can search for MetaTrader4 and install via the App Store.',
  iOS_mobile_version: 'IOS',
  System_requirements_Applicable_to_Windows_2008_7_8_10_operating_system: 'System requirements: Applicable to Windows 2008/7/8/10',
  Windows_desktop_version: 'Windows',
  Download_MetaTrader_4_and_experience_the_best_trading: 'Download MetaTrader 4 for the best trading!',
  Take_profit_price: 'TP',
  Pending_order_price: 'Pending price',
  Order_time: 'Pending time',
  Trading_profit_and_loss: 'Profit',
  Inventory_fee: 'Swaps',
  Stop_loss_price: 'SL',
  Opening_price: 'Open price',
  Lot: 'Lot',
  Trading_symbol: 'Symbol',
  Opening_time: 'Open time',
  Position: 'Position',
  Submitted_please_wait_for_review: 'Submitted, please wait for review',
  Payees_email: "Payee's email",
  Submitted_the_system_will_arrive_within_24_hours: 'Submitted, the payment will receive within 24 hours',
  The_amount_that_can_be_withdrawn_is_0: 'The amount that can be withdrawn is 0',
  Confirm_transfer_out: 'Submit',
  Transfer_another_persons_account: "Transfer to others",
  Transfer_to_self_held_account: 'Transfer to myself',
  Original: 'Original',
  At_least_greater_than_the_minimum_withdrawal_amount: 'At least greater than the minimum withdrawal amount',
  Payment_amount: 'Pay Amount',
  Amount_that_can_be_withdrawn: 'Available amount',
  Payee: 'Payee',
  Complete_time: 'Time',
  Balance_changes: 'Amount',
  Trading_Wallet_Account: 'Trading/Wallet Account',
  serial_number: '#',
  review_time: 'Time',
  Operation_method: 'Method',
  Operation_type: 'Type',

  processing_time: 'Date',
  account: 'Account',
  active_account: 'Login',

  area: 'Area',
  Detailed_address_local_language: 'Detailed address (local language)',
  Upload_supporting_documents: 'Upload supporting documents',
  Make_sure_the_document_shows_your_full_name_full_address_and_the_time_it_was_issued_or_is_vali: 'Make sure the document shows your full name, full address and the time of issue or expiration date.',
  certified_documents: 'Supporting documents',
  Please_upload_one_of_the_following_proof_of_address_documents: 'Please upload one of the following proof of address documents:',
  ID_card: 'ID card',
  driver_license: 'Driving license',
  Property_bills_such_as_electricity_bills_water_bills_gas_bills_etc: 'Property bills (such as electricity bills, water bills, gas bills, etc.)',
  Internet_cable_telephone_bill: 'Internet/cable/telephone bill',
  Bank_statements: 'Bank statements',
  credit_card_bill: 'Credit card statement',
  residence_permit: 'Residence permit',
  Affidavit_Certificate_of_Residence: 'Affidavit/residence permit',
  Household_register: 'Household register',
  Any_government_issued_documents: 'Any government-issued documents',


  Gender: 'Gender',
  Upload_ID_photo: 'Upload ID photo',
  Make_sure_the_ID_photo_document_shows_your_photo_full_name_date_of_birth_and_document_issue_date: 'Make sure the ID photo document shows your photo, full name, date of birth and document issue date.',
  Demonstrate_correctly: 'Correct',
  Error_demonstration: 'Wrong',
  ID_photo_reverse_side: 'ID photo (back)',
  Support_jpg_or_png_format: 'Only jpg or png',
  Photos_are_clear: 'Photos are clear',
  Details_clearly_visible: 'Details are clearly visible',
  Photo_quality: 'High quality photos',
  All_four_corners_of_the_document_are_visible: 'All four corners of the document are visible',
  Photo_is_blurry_and_out_of_focus: 'Photo is blurry and out of focus',
  Details_not_shown_clearly: 'Details not shown clearly',
  Photo_quality_is_low_too_dark_or_too_bright: 'Photo quality is low (too dark or too bright)',
  All_four_corners_not_shown: 'All four corners not shown',
  ID_photo: 'ID photo',
  ID_photo_front: 'ID photo (front)',
  Start_your_trading_journey: 'Start your trading journey',
  undone: 'Undone',
  Trading_System: 'Platform',
  server: 'Server',
  Download_trading_software: 'Download trading software',
  PC_version: 'PC',
  Android_version: 'Android',
  MT4_account: 'Login',
  Leverage_ratio: 'Leverage',
  _8_20_characters_including_uppercase_and_lowercase_letters_and_numbers: '8-20 characters, including uppercase and lowercase letters and numbers',
  Please_select_account_type: 'Please select account type',
  photo: 'Photo',
  Place_of_residence_region: 'Residence',
  proof_of_address: 'Proof of address',
  Local_remittance: 'Local remittance',
  Beneficiary_bank_area: 'Beneficiary bank region',
  China: 'China',
  Beneficiary_bank_name: 'Beneficiary bank name',
  Recipient_bank_account_number: 'Beneficiary bank account',
  Bank_card_front: 'Bank card (front)',
  Bank_card_reverse_side: 'Bank card (back)',
  new_email: 'New email',
  The_current_time_period_is_unavailable: 'Current time is unavailable',
  Currency: 'Currency',
  The_order_was_submitted_successfully_please_wait_for_system_review: 'Order submitted successfully, please wait for system review',
  Continue_to_deposit: 'Continue deposit',
  check_order: 'View order',
  Please_upload_payment_voucher: 'Please upload payment voucher',
  Please_enter_the_Hash_address_after_the_transaction: 'Please enter the Hash address after the transaction',
  Billing_message: 'Payment Information',
  Coin_deposit_address: 'USDT Address',
  payment_voucher: 'Payment voucher',
  The_maps_address: 'Picture address',
  Payer_wallet_address: 'Payer wallet address',
  wallet_address: 'Wallet address',
  Blockchain_transaction_ID: 'Blockchain hash address',
  Hash_address_after_deposit_is_completed: 'Hash address after deposit is completed',
  International_wire_transfer: 'International wires',
  Bank_name: 'Bank name',
  Bank_address: 'Bank address',
  Payee_account: 'Payee account',
  Payee_Address: 'Payee Address',
  Continue_to_withdraw_money: 'Continue withdraw',


  Please_review_and_activate_account: 'Please review and activate account',
  Activation_email_received: 'Activation email received',
  Insufficient_balance: 'Insufficient balance',
  Please_select_a_start_and_end_date: 'Please select a start date and end date',
  Transfer_out_account: 'From',
  Withdrawal_account: 'Withdraw Account',
  depositUsdtTips: [
    '1.After the remittance is completed, please upload a screenshot with the complete hash address to the remittance voucher in the withdrawal record of the digital currency wallet.'
  ],
  depositBankTips: [
    '1.Please use the bank card with the same name as the actual payer to transfer funds.',
    '2.Please do not make habitual transfers, otherwise the money may not be recovered.',
    "3.If the customer's transfer amount exceeds the transfer limit, the money will be credited to the service provider's bank card and is difficult to recover. All losses must be borne by the customer, and the company will not provide any compensation.",
    "4.It is prohibited to provide any remarks when making bank transfers. If any remarks are found, the amount will be returned and 1-2% of the amount will be charged as a handling fee. The first incorrect operation will be reminded by email and no handling fee will be charged. The second time will be borne by the customer. Once there's a third wrong operation, the account will be banned as a malicious customer.",
    '5.If the customer uses a different name to deposit and transfer, 1-2% of the amount will be charged as a refund handling fee and will be refunded through the original method. Deposits under different names are not allowed. Customers must use a bank card in their own name to deposit to avoid unnecessary loss of funds in the future.',
  ],
  Please_upload_a_photo_of_holding_your_ID_card: 'Please upload a photo of holding your ID card',

  digital_currency: 'Digital currency',
  Confirm_payment_information: 'Confirm payment information',
  confirm_payment: 'Confirm',
  upload_image: 'Upload image',
  picture_address: 'picture address',
  main_wallet: 'Main wallet',
  deposit_account: 'Deposit account',
  Your_new_password_must_be_different_from_your_old_password: 'Your new password must be different from your old password',
  Please_enter_the_phone_number: 'Please enter the phone number',
  Please_enter_the_email_address_in_the_correct_format: 'Please enter the correct format of your email address',
  Already_have_an_account: 'Already have an account',
  live: 'Live',

  add_account: 'Add',
  transaction_account: 'Login',
  trade: 'Trade',
  I_have_read_understood_and_agreed: 'I have read, understood and agreed',
  No_account_yet: 'No account found',
  Account_details: 'Account Overview',
  pending_order: 'Pending',

  // 新加的
  The_activation_email_has_been_sent_successfully_Please_go_to_the_email_to_confirm_the_activation_as_soon_as_possible_Thank_you: 'The activation email was sent successfully, please check the email as soon as possible to confirm the activation, thank you!',

  Good_evening: 'Good evening',
  Good_afternoon: 'Good afternoon',
  good_morning: 'Good morning',
  family_name: 'Last name',
  Please_fill_in_the_true_and_valid_information: 'Please fill in the real and valid information',
  register: 'Register',
  Return_to_login: 'Back to login',
  Verification_Code: 'Verification code',
  Send_verification_code: 'Send',
  Verification_mode: 'Verification',
  safety_verification: 'Safety verification',
  Mobile: 'Phone',
  Account: 'Account',
  WelcomeToMaxain: 'Welcome to Maxain',
  // new
  dashboard: 'Dashboard',

  // new
  limitRegistPassOneStep: 'Limit 8-20 characters',


  transaction_status: 'Status',

  home_agent: 'Agent attribute',
  account_information: 'MT4 details',
  account_type: 'Account type',


  // 过渡版本加的
  total: 'Total',
  item: '',
  Whether_the_public: 'Public',
  remark: 'Remark',
  field_name: 'Field',
  table_name: 'Table',
  Input_search: 'Enter search',
  userErrorTips: 'Please enter a combination of letters, numbers and underscores, between 3 and 20 characters in length',
  optional: 'Optional',
  menuName: 'Name',
  loginTimeoutTip: 'Session expired please login again',
  Yes: 'Yes',
  no: 'No',
  please_sign_in: 'Please log in',
  username: 'Username',
  password: 'Passwod',
  Log_in: 'Login',
  Role: 'Role',
  please_choose: 'Please choose',
  please_input: 'Please enter',
  Resign: 'Resignation',
  on_job: 'Employed',
  show: 'Show',
  search: 'Search',
  add: 'Add',
  name: 'Name',
  department: 'Department',
  operate: 'operate',
  Check: 'Check',
  Edit: 'Edit',
  delete: 'Delete',
  principal: 'Principal',
  Confirm: 'Confirm',
  cancel: 'Cancel',
  email: 'Email',
  Superior: 'Superior',
  phone: 'Phone',
  save: 'Save',
  personal_information: 'User Information',
  Menu_name: 'Menu name',
  description: 'Description',
  state: 'Status',
  Merchant: 'Merchant',
  Enable: 'Enable',
  disabled: 'Disable',
  Closure: 'Closure',
  confirm_delete: 'Confirm delete',
  confirm: 'Confirm',
  Please_upload: 'Please upload',
  open: 'Opened',
  closed: 'Closed',
  Component_name: 'Component name',
  Notice: 'Notice',
  Description_optional: 'Description (optional)',
  // 旧个人中心start
  il8n: {
    change: 'Language switching successful',
  },


  Please_select_a_time_range: 'Please select the query time range',
  A_maximum_of_three_months_can_be_queried: 'A single query cannot exceed 3 months',

  Web_trader: 'Web trade',
  balance: 'Balance',
  equity: 'Equity',
  Group: 'Group',

  Redemption_expired: 'Invalid',
  Exchange_successfully: 'Success',
  Exchange_time: 'Redemption time',
  Redeem_products: 'Redeem gift',
  quantity: 'Quantity',
  Deduct_points: 'Point deduction',

  bonus_time: 'Reward time',
  Number_of_points: 'Amount of points',
  Transaction_deposit_amount: 'Trade/Deposit Amount',
  behavior_type: 'Behavior type',
  single_deposit: 'Every deposit',
  first_deposit: 'first deposit',
  behavioral_points: 'Behavior points',
  Trading_Points: 'Trading points',
  Points_Available: 'Points Available',
  redeemed: 'Redeemed',
  Points_record: 'Redemption record',
  Summary_points: 'Total points',
  Points_type: 'Points Type',
  Points_Details: 'Points Details',

  MAM_Account_Details: 'MAM account details',



  Commission_rebate_rules: 'Commission rules',
  Add_a_link: 'Add link',
  Direct_customer_class_name: 'Link name',

  Modify_the_rebate_rules: 'Edit Commission Rules',

  log_in_automatically_after: 'Automatically log in after',

  important_Notice: 'Important Notice',
  do_not_show_again: "Don't show again",
  Got_it: 'Understood',


  mobile_phone: 'Phone',


  Please_upload_the_QR_code: 'Please upload the QR code',
  Please_fill_in_the_address: 'Please fill in the address',

  bind365_tips: 'Please note that must be TRC20 information, otherwise the withdrawal may not be successful.',
  Please_activate_the_binding: 'Please activate the binding',

  Holding_ID_photo: 'Holding ID photo',
  Precautions: 'Notice',
  Handheld_ID_photo_verification_failed: 'Handheld ID photo verification failed',

  idRejectLabel: 'Personal information review failed',
  addressRejectLabel: 'Proof of address review failed',
  bankRejectLabel: 'The bank card information review failed',
  QR_code: 'QR code',
  address: 'Address',
  The_bank_card_information_has_been_submitted_successfully: 'Bank card information submitted successfully',
  Is_binding: 'Binding',
  The_commission_to_USDT: 'To USDT Wallet',
  The_commission_to_OTC365: 'To ChipPay',
  Bank_card_payment: 'To Bank account',
  withdrawOtcTipThirdlyLine: 'The system will pay the digital currency to a third-party digital currency trading platform, and the third-party platform will automatically match the trader and complete the sale of the digital currency. Please ensure that you are aware of the transaction risks before trading.',
  withdrawOtcTipsSecondLine: 'The handling fee is 1 USDT, which is used to pay the mining fee generated by the public chain. Real-time transfer of USDT to OTC365 wallet, built-in acceptance, convenient deposit and withdrawal.',
  withdrawBankCardTipsThirdlyLine: 'In order to comply with the anti-money laundering requirements of regulatory, Maxain payment method will equivalent with customer deposit method.',
  withdrawBankCardTipsSecondLine: '2.Handling fee is free of charge, withdrawal of funds to personal bank card.',
  withdrawUsdtTipsSecondLine: '2.The handling fee is 1USDT, which is used to pay the mining fees generated by the public chain.',
  mamMasterOpenLimitTips: 'Conditions for listing: The rate of return is greater than 0, the equity is greater than $1000, and the indicator is updated once a day',

  MAM_Investor: 'MAM Investor',

  Payment_currency: 'Currency',
  Amount_deposited: 'Deposit amount',
  share_threeMonthsReturn: 'Max DD 90d',
  share_rate_of_return: 'Yield',
  The_poster_has_been_generated_please_share_it: 'Poster has been generated, go and share it',
  Duplicated_link_go_share_it: 'The link has been copied, go and share it',
  Settlement_not_supported: 'Settlement is not supported',
  recommend: 'recommendation',
  Develop_your_customers_through_poster_links: 'Develop your customers through poster links',
  Share_Master_Account: 'Share main account',
  Save_as_a_poster: 'Save as poster',
  copylink: 'copy Link',
  Sweep_code_to_follow_the_master_profit_together: 'Scan the QR code and follow the experts to make profit',
  Close_to_5_liquidations: 'Nearly 5 closed positions',
  Please_select_the_share_proportion: 'Please select the share ratio',
  Please_enter_an_integer_less_than_100: 'Please enter an integer less than 100',
  Follow_Settings_Successfully: 'Follow setup successfully',
  Master_account_special: 'Trading account',
  Follow_the_set: 'Follow setup',
  selected: 'Selected',
  noOpenTips: 'This account has been set to private and currently subscription is not supported.',
  management_rate_of_return: 'Manage yield',
  clientBanlance: 'Clients Balance',
  mamSettingChargeNewTips: ['1. After charging is enable, free subscribers, those who have not started the trading cycle will cancel their subscription, and those who have started the trading cycle will cancel the automatic renewal;',
    '2.Settlement can only be carried out when management period reach 15 days or more and the following account is empty position;',
    '3.It can settle the entire cycle or single following account;',
    '4.Management fees (management funds * management fee ratio) are charged when joining the trading cycle;',
    '5.Performance fee (profit * sharing ratio) is charged at settlement;',
    '6.Accounts that have not been successfully settled will not be charged management fees in the next cycle.'],

  ecnReadyOnlyTips: 'The minimum deposit requirement for an ECN account is ${money}. Trading is unavailable if the requirements are not met',
  mamSubReadyOnlyTips: 'The MAM investment account can only be used for copy trade, autonomous trading are not supported.',
  proReadyOnlyTips: 'The minimum deposit requirement for an PRO account is ${money}. Trading is unavailable if the requirements are not met',

  yesterday: 'Yesterday',
  Nicknames_cannot_be_changed_after_they_are_set: 'The nickname cannot be modified after it is set.',
  autonomous_transaction: 'Self trading',
  Documentary_transactions: 'Copy Trading',
  integerTips: 'Please enter a positive integer',
  StopRatioValiteTips: 'Please enter a multiple of 0.01, which must not exceed 100, with up to two decimal.',

  mamMasterSettingSaveTips: '1.If the public status or subscription fee is modified, automatic renewal will be canceled for all followers; <br/>2.If modified from free to charge, followers who have not started the trading cycle will cancel their subscription, and those who have started the trading cycle will cancel the automatic renewal.',

  attention_please: 'Please note',

  Charge_information_confirmation: 'Charge information confirm',
  You_have_read_and_agree: 'You have read and agreed',
  Documentary_agreement: 'Copy trade agreement',
  Please_enter_your_subscription_password: 'Please enter your subscription password',
  Not_less_than_the_minimum_funds_under_management: 'Not less than minimum management capital',
  Please_select_a_MAM_account: 'Please select MAM account',
  wrong_password: 'Incorrect password',
  Subscribe_to_the_success: 'Subscription successful',
  Unavailable_account: 'Unavailable account',
  Now_open_an_account: 'Open an account',


  Investment_account: 'Invest account',
  copyValidateTips: 'It can only be a multiple of 0.01, and can have up to two decimal.',
  copyValueNullValidateTips: 'Please enter a fixed lot size or fixed ratio',
  maximum_ratio: 'Maximum ratio',
  Now_deposit: 'Deposit now',
  available_balance: 'Available Balance',
  Please_enter_a_multiple_of_10: 'Please enter a multiple of 10',
  mamSubCopyMoneyTips: 'Charged when subscribe. Performance fee is charged at settlement.',
  The_account_to_pay_the_management_fee: 'Account for paying management fees',
  Insufficient_available_balance: 'Insufficient available balance,',
  Edit_success: 'Edited successfully',
  Account_number_has_reached_maximum_limit: 'The number of accounts has reached the maximum limit,',
  The_funds_under_management_must_not_exceed_the_account_balance: 'The managed funds cannot be greater than the account balance',
  Please_enter_managed_funds: 'Please enter management funds',

  Support_for_autonomous_trading: 'For self trading',
  SocialMasterRoleTips: 'Social signal source account',
  SocialSubRoleTips: 'Subscrib & copy the Social signal and allowed self trading',
  mamMasterSubRoleTips: 'MAM asset management trading account,setting the management fee and start trading',
  mamSubSubRoleTips: 'MAM investors copy the main account to manage funds, only follow main account and self trading is not allowed',
  moneyRoleTips: 'Use for managing subscription fees and allowed self trading',

  no_limit: 'No restrictions',
  fixed_lots: 'Fixed lot',
  fixed_proportion: 'fixed ratio',
  Smart_proportion: 'Smart ratio',
  multiple: 'Multiple',
  Experience_account: 'Experience',

  All_have_been_read: 'All read',
  order: 'Order',


  Subscribe_to_the_number_of: 'Subscribers',
  filtrate: 'Filter',
  maximum_drawdown: 'Max DD',
  week: 'Week',
  reset: 'Reset',

  stop: 'Stop',

  Renew: 'Renew',
  cost: 'Expense',

  invalid: 'Invalid',
  valid: 'Valid',
  finished: 'Finished',
  my_subscriptions: 'My subscribe',
  Subscribe_to_my: 'Subscribe to my',

  Investment_community: 'Investment community',
  After_the_nickname_is_set_no_modification_is_allowed: 'No modification is allowed after the nickname is set',
  Wallet_account_edit_tips: 'After modification, the original wallet account will become a normal account',
  Confirm_save: 'Confirm to save',
  idChangeTips: 'The account identity cannot be changed after it is set. Confirm save?',

  please_enter: 'Please enter',
  Account_identity: 'Account Type',
  Account_identity_tips1: 'Normal account: Use for self trading;',
  Account_identity_tips2: 'Wallet account: Use for managing subscription fees and allowed self trading;',
  Account_identity_tips3: 'Social trading account: Social signal account;',
  Account_identity_tips4: 'Social investment account: Subscrib & copy the Social signal and allowed self trading;',
  Account_identity_tips5: 'Main account(MAM): Asset Management trading account,setting the management fee and start trading;',
  Account_identity_tips6: 'Investor account(MAM): Investors copy the main account to manage funds, only follow main account and self trading is not allowed;',

  My_balance: 'Balance',
  mamCancleTips: 'After canceling the subscription, all open orders will be closed and unexpired services will not be available. The management fee is non-refundable, and the performance fee must wait for settlement by the system. Confirm cancel?',
  Time_spent: 'Time',
  Saved_successfully: 'Saved',
  Not_set: 'Unset',

  Total_subscription_revenue: 'Subscription revenue',
  To_open_the_next_issue: 'To be opened',
  Subscription_yield: 'Yield',

  Total_revenue: 'Total revenue',
  Management_fee_ratio: 'Management fee ratio',
  Performance_fee_ratio: 'Performance fee ratio',
  Follow_income: 'Follow profit',
  Please_enter_the_management_fee_ratio: 'Please enter the management fee ratio',
  Please_enter_the_share_ratio: 'Please enter the share ratio',
  Fill_in_at_least_one_charging_rule: 'Fill in at least one charging rule. Management fee and performance fee sharing cannot both be 0.',

  Settled_successfully: 'Settlement successful',
  To_enable_the: 'Enabled',
  noEnableTheTips: 'The trading cycle is less than 15 days and does not meet the settlement conditions',
  Pending_settlement: 'Pending settlement',
  settled: 'Settled',
  Customer_nickname: 'Nickname',

  Trading_cycle: 'Trading cycle',
  Settlement_conditions: 'Settlement conditions',
  cycleTips1: 'The trading cycle is less than 15 days',
  cycleTips2: 'Follow account empty position',
  settle: 'Settlement',
  Settlement: 'Settlement in progress',
  Issue: 'Issue',
  Management_days: 'Days',
  Personal_funds: 'Funds',
  Personal_gain: 'Profits',
  Manage_funds: 'Funds',
  Management_income: 'Manage profits',
  Estimate: 'Estimate',

  startBeforeTipsTitle: 'Confirm activate',
  startBeforeTips: 'After activation, a new trading cycle will begin. The copy settings will take effect and management fees will be deducted. Confirm activation.',
  Successfully_activated: 'Activated successfully',
  settleBeforeTips: 'The copy trade function will be turned off during the settlement period. After it is enabled, it will be re-enabled. Confirm settlement?',
  Confirm_settlement: 'Confirm settlement',

  Cumulative_number_of_managed_accounts: 'Management accounts',
  Number_of_trading_periods: 'Management times',
  Accumulated_funds_under_management: 'Total management funds',
  Average_management_rate_of_return: 'Average management yield',
  Total_Management_Revenue: 'Total management profits',
  Average_billing_cycle: 'Average period',
  Total_personal_income: 'Personal profit',
  Transaction_order: 'Order numbers',

  Stop_loss_ratio: 'Stop loss ratio',
  Charging_cycle: 'Period',
  Resubscribe: 'Resubscribe',

  signal_source: 'Signal',
  Allocation: 'Copy mode',
  transactions: 'Transactions',
  Maximum_follow_number: 'Maximum number of copy positions',
  Maximum_follow_lot: 'Maximum lot of copy positions',
  Follow_the_order: 'Copy status',
  Edit_subscription: 'Edit',
  unsubscribe: 'Unsubscribe',
  socialSubCancelCopyButtonText: 'Confirm cancel',
  cancleSuccess: 'Cancellation successful',


  expenses: 'Expenses',

  Autonomous_transaction: 'Self trading',
  Copy_transaction: 'Copy trading',
  Autonomous: 'Self',


  Is_it_public: 'Whether public',
  Follower_funding_limit: 'Follower funds limit',
  Unlimited: 'Unlimited',
  Subscription_password: 'Subscription password',
  digit6_combination_of_numbers_and_letters: '6-20 digits of numbers and letters',
  charge: 'Charge',

  nickname: 'Nickname',

  Copy_settings: 'Settings',

  Payment_time: 'Payment time',
  month: 'Month',
  types_of_fee: 'Type',
  payment_account: 'Payer',
  Pay_on_behalf_of: 'Pay on behalf of',
  Collection: 'Collect on behalf of',
  Accounts_receivable: 'To',

  Cumulative_number_of_follow: 'Number of copy',
  Cumulative_follow_lot: 'Lots of copy',


  Turned_on: 'On',
  Not: 'Off',
  Automatic_renewal: 'Renewal',
  Current_follow: 'Copy order',
  Current_follow_lot: 'Copy lots',
  Subscription_revenue: 'Copy profit',
  Subscription_days: 'Copy days',

  Subscribing: 'Subscribing',
  expired: 'Expired',

  Cumulative_subscription: 'Subscriptions',
  Cumulative_subscription_revenue: 'Subscription revenue',
  Cumulative_subscription_lot: 'Total copy lots',
  income: 'Revenue',


  Profitability: 'Profitability',
  Robustness: 'Robust ability',
  Risk_control_ability: 'Risk control ability',
  Fund_size: 'Fund size',
  Trading_activity: 'Trading activity',

  Grand_total: 'Total',
  Today: 'Today',
  Nearly_three_months: '3 months',
  Short: 'Short',
  Do_more: 'Long',
  Variety_ranking: 'Symbol rank',
  Yield_curve: 'Performance',

  Basic_Information: 'Basic Information',
  Subscription_fee: 'Subscription fee',
  free: 'Free',
  Experience: 'Experience',
  Share_ratio: 'Share ratio',
  Performance_fee: 'Performance fee',

  management_fee: 'Management fee',
  No: 'No',
  Strategy_description: 'Strategy description',
  Minimum_funding_limit: 'Minimum limit',
  Master_account: 'Main',
  rate_of_return: 'Yield',
  threeMonthsReturn: 'Max DD 90d',
  Overview: 'Overview',
  Setting: 'Setup',
  subscription: 'Subscription',
  Please_enter_a_nickname: 'Please enter a nickname',
  Wallet_account: 'Wallet',
  Social_account: 'Social account',
  MAM_account: 'MAM account',
  MAM_master_account: 'Trading account',
  MAM_Investment_Account: ' Invest account',
  Social_master_account: 'Social main account',
  Social_Investment_Account: 'Social invest account',
  You_can_also_add: 'Add new',
  Trading_accounts: 'Login',
  More: 'More',
  Read_only: 'Read only',
  Identity: 'ID',

  readOnlyTips: 'The credit limit is frozen because the net worth is lower than the credit limit. You can deposit money again and contact customer service to apply for unfreezing and continue completing the task. You can also cancel the credit limit and unfreeze it directly.',
  stopRatioExplain: 'When current equity/initial equity ≤ set ratio, copy trade will be suspended, all open positions will be forcibly closed, and the stop loss ratio will be reset. This value will be reset after making a deposit, withdrawal or transfer.',
  mtAccount: 'Login',
  bind: 'Bind',
  riskFileName: 'Risk disclosure',
  saveFileName: 'Safety instructions',
  and: 'And',
  limitRegistPassTwoStep: 'Contains uppercase and lowercase letters and numbers',

  welcome: 'Welcome to',
  GoToRegister: 'Go to register',

  resetPass: 'Reset password',
  To_log_in: 'Go to login',

  personal: 'Personal',
  partner: 'Partner',
  phoneEmtpyTips: 'Phone number cannot be empty',
  select_rebate_level: 'Please select refer level',
  editSuceess: 'Successfully modified',
  Modify_agent_level: 'Modify refer level',
  Please_enter_password: 'Please enter password',
  please_input_your_email: 'Please enter email',
  registration_success: 'Registration successful',
  Please_keep_your_password_properly: 'Please keep your password safe',
  log_in_immediately: 'Log in now',
  Upload_positive: 'Upload front side',
  Upload_negative: 'Upload back side',
  Privacy_agreement: 'Privacy agreement',
  Prevent_money_laundering: 'Anti money laundering',
  safety_instructions: 'Safety instructions',
  infoRejectTips: 'Please follow the email prompts to modify the information and resubmit it.',
  Authenticate_now: 'Authenticate now',
  My_rebate_rules: 'My rules',
  The_highest_can_be_set: 'Maximum settable',
  Please_fill_out: 'Please fill out',
  Fill_in_at_most_one_decimal: 'Maximum one decimal',
  Commission_statistics: 'Commission statistics',
  today: 'Today',
  All: 'All',
  Nearly_a_month: '1 month',
  Nearly_a_year: '1 year',
  Unbound: 'No binding',
  Home_agent: 'Agent attribute',
  client: 'Customer',
  Myself: 'Myself',
  All_subordinates: 'All subordinates',
  Self_held_account_transfer_and_withdrawal: 'Transfer and withdraw funds from self-held account',
  Transfer_and_withdraw_funds_from_other_accounts: "Transfer and withdraw funds from other's accounts",
  Bank_card: 'Bank card',
  Alipay: 'Alipay',
  other: 'Other',
  credit_amount: 'Credit',
  Open_a_position: 'Open position',
  Account_type: 'Account type',
  normal: 'Normal',
  Agent_ID: 'IB ID',
  direct: 'Direct',
  indirect: 'Sub',
  Authentication_failed: 'Authentication failed',
  Account_under_name: 'Login',
  Registration_time: 'Registration time',
  modify: 'Modify',
  Commission: 'Withdraw',
  Choose_verification_method: 'Select verification method',
  correct: 'Correct',
  Investment_objective: 'Investment objectives',
  of: 'of',
  Transaction_history: 'Trade History',
  Limit_more_than_6_characters: 'Limit more than 6 characters',
  Contains_letters_and_numbers: 'Contains letters and numbers',
  Direct_link: 'Client link',
  mine: 'My',
  Re: 'Re',
  uploadAddressFileSuccessTips: 'Address file uploaded successfully',
  Need_to_log_in_again: 'Need to login again',
  Ordinary_account: 'Normal',
  Demo_account: 'Demo',
  openAccPageTips: 'Some financial varieties may be affected by fixed margin requirements, causing your actual leverage to be lower than the leverage selected in the account settings. For specific information, please refer to the "Contract Details" or visit our website.',
  mockOpenSuccessTip: 'Demo account opened successfully',
  Total_deposit: 'Total deposit',
  Total_withdrawal: 'Total withdrawal',
  Apply_to_transfer_out: 'Apply for transfer out',
  profit: 'Profit',
  Bank_card_number: 'Bank card number',
  Transfer_out_to_bank_card: 'Transfer to bank card',
  Transfer_to_MT4: 'Transfer to MT4',
  experienceNoCardTips: 'Please bind your bank card before transfer',
  experienceNoMt4Tips: 'Please create an mt4 account',
  Account_has_expired: 'Account has expired',
  personInfoAuthFail: 'The review failed',
  day: 'Day',
  mobileAreaTips: 'Please select the region',
  details: 'Details',
  accountDetails: 'Account details',
  orderSource: 'Order source',
  root: {
    selectPls: 'Please select',
    enterPls: 'Please enter content',
    confirm: 'Confirm',
    cancle: 'Cancel',
    noData: 'No data',
    dateTo: 'to',
    startDate: 'Start',
    endDate: 'End',
    search: 'Search',
    export: 'Export',
    time: 'Time',
    upper: 'Previous',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    selectAccount: 'Select account',
  },
  HeaderCom: {
    login: 'Login',
    register: 'Register',
    userCenter: 'Client Area',
    invite: 'Invite',
    exit: 'Exit',
  },
  LoginOut: {
    success: 'Logout successfully'
  },
  Login: {
    login: 'Login',
    passwordTip: 'Password',
    forgetPwd: 'Forgot password',
    register: 'Register',
    phoneVer: 'Phone',
    emailVer: 'Email',
    successSetPwd: 'Password reset successful',
    loginTimeoutTip: 'Your account login has expired, please log in again.',
  },
  Register: {
    title: 'Register',
    perInfo: 'User Information',
    declare: 'Declaration',
    firstName: 'Last name',
    lastName: 'First name',
    rePswText: 'Confirm Password',
    againVer: 'Get it again after',
    errorPhon: 'Please enter the correct phone number',
    errorMail: 'Please enter the correct email number',
    errorFirstName: 'Please enter last name',
    notpassword: 'Incorrect password',
    notrepassword: 'The passwords entered twice are inconsistent, please re-enter',

    passwordDes: "Must contain uppercase and lowercase letters and numbers. Special characters cannot be used. The length should be between 8-20 characters.",
    verText: "Verification code",
    submitText: 'Submit',
    successTips1: 'The activation link has been sent to your registered email address.',
    successTips2: ',Please check and activate your account',
    successTips4: 'Resend',
    successTips5: 'The activation email was sent successfully, please check the email to confirm the activation, thank you!',
    sendEmail: 'Send activation email',
    unCheck: 'inactivated',
    userName: 'Username',
    idNo: 'ID number',
    openAcc: 'Confirm open an account',
  },
  About: {
    branch: 'Office',
    phone: 'Phone',
    language: 'Language',
    sendEmail: 'Send email',
    name: 'Name',
    email: 'Email',
    submitText: 'Submit',
    notice: 'Notices',
  },
  Home: {
    least: 'Minimum deposit',
    lever: 'Leverage',
    accountType: 'Type',
    forexVolume: 'Volume',
    forexLot: 'Lot',
  },
  Partner: {
    name: 'Name',
    email: 'Email',
    region: 'Please specify the region in which you plan to operate',
    experience: 'Have you worked with other financial companies? If so, please indicate which companies they are and when?',
    upload: 'Upload',
    inputVer: 'Please enter verification code',
    commitSuccess: 'Submitted successfully',
    delete: 'Confirm removal',
  },
  Tools: {
    exchange: 'Currency converter',
    year: 'Year',
    month: 'Month',
    day: 'Day',
    USD: 'USD',

  },
  Trade: {
    equity: 'Equity(USD)',
    payType: 'Payment system',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    oper: 'Operate',
    mix: 'Min',
    max: 'Max',
    poundage: 'Handling fees',
    depo: 'Deposit',

    /*新的银联支付方式*/
    title: 'Payment amount and confirm',
    subtitle: 'After top up, the digital currency you purchased will be fully top up to the merchant.',
    orderNo: 'Ticket',
    payMoney: 'Payment amount',
    copy: 'Copy',

    bankInfo: 'Bank information:',
    remark: 'Payment remarks:',
    countDown: 'Payment countdown:',
    warning: 'Warning: If the transfer is unsuccessful, please do not click "Confirm Payment", otherwise the purchase and deposit will be restricted on the same day!',
  },
  Train: {
    all: 'All',
    class: 'Classification',
    sort: 'Sort',
    lecturesAddr: 'Address',
    viewMore: 'View more',
    apply: 'Register now',
    firstName: 'Last name',
    lastName: 'First name',
    experience: 'Experience',
    phone: 'Phone number',
    email: 'Email',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
  },
  Market: {
    calendar: 'Economic calendar',
    time: 'Time',
    event: 'Event',
    important: 'Importance',
    now: 'Now',
    pre: 'Former value',
  },
  User: {
    home: 'Home',
    myAcc: 'My account',
    monChan: 'Deposit',
    partner: 'Partner',
    perInfo: 'User Information',
    goldManage: 'Bonus',
    setup: 'Account settings',
    leastDeposit: 'Minimum deposit',
    leverage: 'Leverage',
    leverageBest: 'Maximum leverage',
    unit: 'Minimum contract size',
    miniSpreads: 'Minimum spread',
    selectLev: 'Please select leverage',
    currency: 'Account currency',
    openAcc: 'Open an account',
    accountList: 'Accounts',
    totalBalance: 'Total balance',
    applyCommi: 'Apply for commission',
    status: 'Status',
    remainAmount: 'Amount of commission available',
    transactionStatus: 'Status',
    startUsing: 'Enable',
    forbidden: 'Disable',
    login: 'Account',
    accType: 'Type',
    balance: 'Current balance',
    equity: 'Current equity',
    credit: 'Credit amount',
    marginFree: 'Free margin',
    profitRate: 'Total account profit margin (%)',
    openOrder: 'Open orders',
    closeOrder: 'Closed orders',
    createTime: 'Registration date',
    checking: 'Under review',
    userInfo: 'Personal information',
    name: 'Name',
    surnameNullMessage: 'Please enter last name',
    nameNullMessage: 'Please enter first name',
    regionNullMessage: 'Please select the area',
    gender: 'Gender',
    man: 'Mr.',
    women: 'Mrs.',
    nationality: 'Nationality',
    homeCountryCode: 'Country of residence',
    phone: 'Phone number',
    certId: 'ID number',
    birthday: 'Date of birth',
    authentication: 'Base info',
    authPass: 'Success',
    authing: 'Process',
    addressVerifi: 'Address',
    sumit: 'Submit',
    authSubmitSuccess: 'Identity submitted successfully',
    add: 'Add',
    email: 'Email',
    newPhone: 'New phone number',
    sendVeri: 'Send',
    sendDesc: 'Get it again after',
    phoneVerCode: 'Phone verification code',
    emailVerCode: 'E-mail verification code',
    save: 'Save',
    verCodeSendSuccess: 'Verification code sent successfully',
    plsInputNewPhone: 'Please enter your new phone number',
    plsInputPhoVer: 'Please enter verification code',
    addPhoneSuccess: 'Added successfully',
    worlSta: 'Employment status',
    industry: 'Industry',
    income: 'Annual income',
    netAsset: 'Net assets',
    curAsset: 'Current assets',
    fundsSource: 'Source of investment funds',
    bankCardInfo: 'Bank card information',
    bankAccount: 'Bank account',
    bankName: 'Bank name',
    receivingCurrency:"Account currency",
    account_currency:"Account currency",
    bankOutlet: 'Bank Branch',
    reBind: 'Rebind',
    worlStaNullMessage: 'Please select employment status',
    industryNullMessage: 'Please select an industry',
    incomeNullMessage: 'Please select annual income',
    AssetsNullMessage: 'Please select net assets',
    runAssetsNullMessage: 'Please select your current assets',
    fundsSourceNullMessage: 'Please tick your current assets',

    plsInputBankFront: 'Please upload a photo of your bank card (front)',
    plsInputBankBack: 'Please upload a photo of your bank card (back)',
    plsInputBankAccount: 'Please enter bank account number',
    plsInputBankName: 'Please enter the issued bank',
    plsInputBankOutlet: 'Please enter the bank branch',
    CNYNAME:"RMB",
    VNDNAME:"VND",
    OTHER_BANKS:"Other banks",
    plsInputSwiftCode: 'Please enter SwiftCode',
    investExp: 'Investment experience',
    invTarget: 'The investment goal is',
    levHis: 'Please tell us whether you have any trading history of other leveraged products (such as warrants, futures, options)',
    howTrade: 'How do you trade the above products?',
    invTargetIs: 'What is your investment goal? (Multiple choice)',
    plsInputInvTarget: 'What is your investment goal?',
    firstName: 'Last name',
    cardType: 'ID Type',
    plsInputAddress: 'Please select a region',
    plsInputName: 'Please enter your name',
    openAccTips3: 'I think the products of  your company offers are suitable for me',
    openAccTips4: 'I understand that this investment product is speculative and I can risk the entire investment amount based on my personal financial situation',
    openAccTips5: 'I understand that when trading leveraged products, I run the risk of losing all funds invested; it is my responsibility to monitor my positions and manage trading risks through risk management tools (such as stop-loss orders).',
    openAccTips6: 'I agree that the customer agreement and all terms will be collected and sent in electronic form rather than paper form, including electronic signature of documents and sending of account information.',
    openAccTips7: 'In addition, I declare that all the account opening information I provide is true and accurate, and I guarantee that I will notify the brokerage company in writing if there are any changes in the content. If necessary, I authorize the brokerage company to verify the accuracy of the information.',

    //转账
    transferAccounts: 'Fund transfer',
    from: 'From',
    to: 'to',
    amount: 'Amount',
    onlyInputTwoBitNumber: 'Only two decimal can be entered.',
    transDesc: 'If you know the recipient’s email address (either the primary email for the recipient’s or any alternate email address), please enter it. The system will verify that the recipient account number and email address. If they do not match, the internal transfer will not be performed.',
    transAmount: 'Transfer amount',
    fee: 'Handling Fee',
    //tradeHistory
    payType: 'Payment method',
    num: 'Ticket',
    searchType1: 'UnionPay deposit 1',
    searchType2: 'Transfer from self-held account',
    searchType3: "Transfer from other's account",
    searchType4: 'UnionPay deposit 2',
    searchStatus2: 'Deposit successful',
    searchStatus3: 'Deposit failed',
    outAmount: 'Withdrawal amount',
    searchOutType1: 'Withdraw to bank card',
    searchOutType2: 'Withdraw to your own account',
    searchOutType3: 'Withdraw to other’s accounts',
    searchOutType4: 'Others',
    searchOutStatus1: 'Under review',
    searchOutStatus2: 'Withdraw successfully',
    searchOutStatus3: 'Withdrawal failed',
    depositTimeTips:'This channel is not available during the time period. Please choose another channel. Thank you!',
//moneyChange
    in: 'Deposit',
    out: 'Withdraw',
    limit: 'Limit',
    timeLimit: 'Limited time',
    moneyConfirm: 'Confirm',
    moneyBanlanceNotEnough: 'Insufficient available balance, please choose another account to withdraw',
    moneyAmountError: 'The withdrawal amount is greater than the amount that can be withdrawn',
    //setting
    leverSet: 'Leverage settings',
    modifyLeverSuccess: 'Leverage modification successful',
    saveSetting: 'Save',
    passSet: 'Password settings',
    newPass: 'New Password',
    confirmPass: 'Re-enter password',
    plsInputPass: 'Please enter new password',
    plsInputConfirmPass: 'Please enter the confirmation password',
    modifyPass: 'Change password',
    passType2: 'Trading password',
    passType3: 'Invest password',
    passSetSuccess: 'Password has been updated',
    //partner
    commissionBanlance: 'Balance',
    totalProfit: 'Total revenue',
    copySuccess: 'Copied successfully',
    reportCloseOrder: 'Close order',
    reportSubibList: 'Sub-IB',
    reportCommiRecord: 'Withdraw record',
    reportOrderId: 'Ticket',
    reportCusId: 'Customer ID',
    reportSymbol: 'Sybmol',
    reportCmd: 'Type',
    reportVolume: 'Trading volume',
    reportCurrentPrice: 'Close price',
    reportCloseTime: 'Close time',
    reportClosePrice: 'Close price',
    reportSl: 'SL',
    reportTp: 'TP',
    reportStorage: 'Swaps',
    reportProfit: 'Profit',
    total: 'Total',
    buy: 'Buy',
    sell: 'Sell',
    reportCusType: 'Type',
    reportBanlance: 'Balance',
    reportEquity: 'Equity',
    reportImgStatus: 'Data authentication',
    reportCreateTime: 'Opening time',
    reportDir: 'Client',
    reportIndir: 'Sub customer',
    auth: 'Authenticate',
    identifyStatus0: 'Unauthenticated',
    identifyStatus1: 'Authentication failed',
    identifyStatus2: 'Under authentication',
    identifyStatus3: 'Authentication passed',
    custStatus2: 'Account opening successful',
    custStatus3: 'Under review',
    custStatus4: 'Review failed',
    reportComiType: 'Withdraw method',
    reportComiType1: 'To Bank card',
    reportComiType2: 'Internal transfer',
    reportCommiAmount: 'Amount',
    reportCommiStatus1: 'Success',
    reportCommiStatus2: 'Rejected/cancelled',
    reportCommiStatus3: 'Under review',
    applyTime: 'Apply'
  },
  contractDetailed: {
    tradingHour: 'Trading period',
  },
  riskExplain: {
    title: 'Risks and Disclaimers'
  },
//电汇
  telegraphicTransfer: {
    tips: 'Safe Transaction Instructions',
  },
// 赠金
  withgold: {
    title: 'Bonus',
    Numbering: 'Ticket',
    accountNumber: 'Login',
    BonusType: 'Type',
    BonusAmount: 'Bonus amount',
    DepositAmount: 'Deposit amount',
    EventName: 'Event',
    NumberOfLots: 'Required',
    LotsCompleted: 'Completed',
    ExpireDate: 'Expiration',
    status: 'Status',
    freeStatusTipsOne: 'The credit limit is frozen because the equity is lower than the credit limit.',
    freeStatusTipsTwo: 'Please deposit and contact account manager to unfreezing and continue completing the task,',
    freeStatusTipsThree: 'You can also cancel the credit limit and unfreeze it directly.',
    operating: ' ',
    RollOut: 'Transfer',
    statusEnd: 'Ended',
    statusDuring: 'Ongoing',
    statusExpired: 'Expired',
    statusFree: 'Freeze',
    statusComple: 'Completed',
    statusCancle: 'Cancelled',
    statusReview: 'Regular review',
    sureTitle1: 'Available amount',
    sureTitle2: 'Transfering the bonus has the risk of triggering stopout positions, It is recommended to apply when you have no positions.',
    sureTitleCenter: 'Transfer to balance',
    operatingSuccess: 'Success',
    cancleTitle: 'Canceling the bonus has the risk of triggering stopout positions. It is recommended to apply when you have no positions.',

    // 转出记录页面
    mt4Account: 'MT4 account',
    RollOutAmount: 'Transfer amount($)',
    SubmitTime: 'Application time',
    withgoldOut1: 'Pending review',
    withgoldOut2: 'Passed',
    withgoldOut3: 'Rejected',

    // 头部
    selectAccount: 'Please select an account',
    inputEventName: 'Please select an event',
    clearEmipt: 'Reset',

    // tab
    TransferRecord: 'Bonus records',
    // 账号冻结状态的提示
  },
  payChannel: {
    inputMoney: 'Please enter the deposit amount',

  },

}
